var Vendd = (function (Vendd) {
	'use strict';

	var model = null;
	var pending = false;


	Vendd.MessageBus.subscribe(Vendd.UserSelect.Messages.SubmitSetInterfaceUser, Vendd.UserSelect, function (envelope) {
	    var options = {
	        url: 'AuthService.svc/SetInterfaceUser',
	        data:
            {
                loginName: envelope.message.data.model.loginName
            },
	        onSuccess: onSuccess,
	        onFailure: onFailure
	    };

	    function onSuccess(response) {
	        if (response.success === true) {
	            Vendd.MessageBus.publishAsync(Vendd.UserSelect, new Vendd.UserSelect.Messages.SubmitSetInterfaceUserSuccess(response));
	        } else {
	            Vendd.MessageBus.publishAsync(Vendd.UserSelect, new Vendd.UserSelect.Messages.SubmitSetInterfaceUserFailure(response));
	        }
	    };

	    function onFailure(response) {
	        Vendd.MessageBus.publishAsync(Vendd.UserSelect, new Vendd.UserSelect.Messages.SubmitSetInterfaceUserFailure(response));
	    };

	    Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.UserSelect.Messages.ClearInterfaceUser, Vendd.UserSelect, function (envelope) {
	    var options = {
	        url: 'AuthService.svc/ClearInterfaceUser',
	        data: { },
	        onSuccess: onSuccess,
	        onFailure: onFailure
	    };

	    function onSuccess(response) {
	        if (response.success === true) {
	            Vendd.MessageBus.publishAsync(Vendd.UserSelect, new Vendd.UserSelect.Messages.ClearInterfaceUserSuccess(response));
	        } else {
	            Vendd.MessageBus.publishAsync(Vendd.UserSelect, new Vendd.UserSelect.Messages.ClearInterfaceUserFailure(response));
	        }
	    };

	    function onFailure(response) {
	        Vendd.MessageBus.publishAsync(Vendd.UserSelect, new Vendd.UserSelect.Messages.ClearInterfaceUserFailure(response));
	    };

	    Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.UserSelect.Messages.SearchUsers, Vendd.UserSelect, function (envelope) {
	    var options = {
	        url: 'AuthService.svc/SearchUsers',
	        data: {
	            minChars: envelope.message.data.model.MinChars,
	            maxHeight: envelope.message.data.model.MaxHeight,
	            zIndex: envelope.message.data.model.ZIndex,
	            deferRequestBy: envelope.message.data.model.DeferRequestBy,
	            noCache: envelope.message.data.model.NoCache,
	            onSelect: envelope.message.data.model.OnSelect
	        },
	        onSuccess: onSuccess,
	        onFailure: onFailure
	    };

	    function onSuccess(response) {
	        if (response.success === true) {
	            Vendd.MessageBus.publishAsync(Vendd.UserSelect, new Vendd.UserSelect.Messages.SearchUsersSuccess(response));
	        } else {
	            Vendd.MessageBus.publishAsync(Vendd.UserSelect, new Vendd.UserSelect.Messages.SearchUsersFailure(response));
	        }
	    };

	    function onFailure(response) {
	        Vendd.MessageBus.publishAsync(Vendd.UserSelect, new Vendd.UserSelect.Messages.SearchUsersFailure(response));
	    };

	    Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.UserSelect.Messages.SubmitSetInterfaceUserInlineAdmin, Vendd.UserSelect, function (envelope) {
	    var options = {
	        url: 'AuthService.svc/SetInterfaceUser',
	        data: {
	             loginName: envelope.message.data.model.LoginName
	        },
	        onSuccess: onSuccess,
	        onFailure: onFailure
	    };

	    function onSuccess(response) {
	        if (response.success === true) {
	            Vendd.MessageBus.publishAsync(Vendd.UserSelect, new Vendd.UserSelect.Messages.SubmitSetInterfaceUserSuccess(response));

	            if (envelope.message.data.model.RedirectToAccount) {
	                var redirectUrl = LhApp.Context.OrdersHistoryUrl; 

	                if (envelope.message.data.model.OrderId) { 
	                    redirectUrl = LhApp.Function.Url.setParameterValueOnUrl(redirectUrl, "oIds", envelope.message.data.model.OrderId);
	                }
	                window.location.href = redirectUrl;
	            } else {
	                location.reload();
	            }

	        } else {
	            Vendd.MessageBus.publishAsync(Vendd.UserSelect, new Vendd.UserSelect.Messages.SubmitSetInterfaceUserFailure(response));
	        }
	    };

	    function onFailure(response) {
	        Vendd.MessageBus.publishAsync(Vendd.UserSelect, new Vendd.UserSelect.Messages.SubmitSetInterfaceUserFailure(response));
	    };

	    Vendd.Service.call(options);
	});

	return Vendd;

})(Vendd || {});